/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateChainContactRequestJobMutationRequest,
  CreateChainContactRequestJobMutationResponse,
  CreateChainContactRequestJob400,
} from '../types/CreateChainContactRequestJob'

function getCreateChainContactRequestJobUrl() {
  const res = { method: 'POST', url: `/api/v1/contact_request/chain/` as const }
  return res
}

/**
 * @summary Create a contact request job for restaurant/bar chains
 * {@link /api/v1/contact_request/chain/}
 */
export async function createChainContactRequestJob(
  data: CreateChainContactRequestJobMutationRequest,
  config: Partial<
    RequestConfig<CreateChainContactRequestJobMutationRequest>
  > & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateChainContactRequestJobMutationResponse,
    ResponseErrorConfig<CreateChainContactRequestJob400>,
    CreateChainContactRequestJobMutationRequest
  >({
    method: 'POST',
    url: getCreateChainContactRequestJobUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
